/**
 * @file 登录页面
 * @author  fangsimin
 * @date    2019-01-11 16:13:02
 * @last Modified by    fangsimin
 * @last Modified time  2019-01-14 21:43:01
 */

<template>
    <el-card class="box-card">
        <el-form :model="formData" status-icon :rules="rules"
            ref="loginForm" label-width="0" class="demo-ruleForm">
            <el-form-item prop="name">
                <el-input type="text"
                    v-model="formData.name" autocomplete="off">
                    <i slot="prefix" class="el-input__icon fas fa-user"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type="password"
                    v-model="formData.password" autocomplete="off">
                    <i slot="prefix" class="el-input__icon fas fa-lock"></i>
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="login-btn"
                    :loading="loginLoading"
                    @click="submitForm()">
                    {{$t('message.login')}}
                </el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
// import request from '@/common/request';
import constants from '@/constants';
export default {
    data() {
        return {
            loginLoading: false, // 是否正在登录中
            // 表单数据
            formData: {
                name: '',
                password: ''
            },
            // 验证规则
            rules: {
                password: [
                    { required: true, message: this.$i18n.t('message.hintRequirePassword'), trigger: 'blur' }
                ],
                name: [
                    { required: true, message: this.$i18n.t('message.hintRequireUsername'), trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        submitForm() {
            this.$refs['loginForm'].validate((valid) => {
                if (valid) {
                    this.$request({
                        loadingKey: 'loginLoading',
                        method: 'post',
                        url: constants['api']['login'],
                        success(response) {
                            let data = response && response['data'];
                            // 验证通过跳转首页
                            if (data['status']) {
                                this.$router.push({
                                    path: constants['path']['home']
                                });
                            } else {
                                this.$message.error(this.$i18n.t('message.loginError'));
                            }
                        }
                    }, this.formData);
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs['loginForm'].resetFields();
        }
    }
};
</script>

<style scoped>
.box-card {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
}
.login-btn {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue